module.exports = __webpack_public_path__ + "img/icon-2.8bbddd73.png";